import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import { EditSceneModal } from 'redux/modules/modal/types';

export default function useEditSceneModal() {
  const {
    onExited,
    onHide,
    params: { videoId, segmentId } = {},
    show,
  } = useConnectedModal<EditSceneModal>('EditScene', {
    closeModalOnUnmount: false,
  });

  return {
    onExited,
    onHide,
    segmentId,
    show,
    videoId,
  };
}
